<template>
  <div class="accordion" id="accordionTableroControl">
    <div class="accordion-item opcionDetalle">
      <h2 class="accordion-header" id="headingTableroControl">
        <button
          class="accordion-button collapsed btn btn-primary rounded-pill"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#collapseTableroControl"
          aria-expanded="false"
          aria-controls="collapseTableroControl"
        >
          Tablero de Control
        </button>
      </h2>
      <div
        id="collapseTableroControl"
        class="accordion-collapse collapse"
        aria-labelledby="headingTableroControl"
        data-bs-parent="#accordionTableroControl"
      >
        <div class="accordion-body">
          <div class="row">
            <div class="col-md-12 col-lg-6 col-sm-6">
              <div
                class="
                  card card-body
                  text-start
                  mb-3                  
                  cabeceraDetalleI
                  parametros
                "
              >
                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div class="text-end m-auto" style="width: 65%">
                    <spam style="font-size:13px">TITULAR</spam>
                  </div>
                  <div class="text-end m-auto" style="width: 25%">
                    <spam style="font-size:12px">COTITULAR | OS</spam>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div class="m-auto" style="width: 40%">
                    Capacidad de pago % (PTI)
                  </div>
                  <div class="text-end m-auto" style="width: 15%">
                    {{ $filters.PercentFilter(operacion.capacidadPago) }}
                  </div>
                  <div
                    class="text-end m-auto"
                    style="width: 10%"
                    v-if="operacion.tipoProducto == 'Tradicional'"
                  >
                    <i
                      :class="
                        `bi bi-record-circle ms-3 iconoE ${obtenerColor(
                          'cp',
                          operacion.capacidadPago
                        )}`
                      "
                    ></i>
                  </div>
                  <div
                    class="text-end m-auto"
                    style="width: 10%"
                    v-if="operacion.tipoProducto == 'Flexible'"
                  >
                    <i
                      :class="
                        `bi bi-record-circle ms-3 iconoE ${obtenerColorFlex(
                          'cp',
                          operacion.capacidadPago
                        )}`
                      "
                    ></i>
                  </div>
                  <div class="text-end m-auto" style="width: 15%"></div>
                  <div class="text-end m-auto" style="width: 10%"></div>
                </div>

                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div class="m-auto" style="width: 40%">
                    Capacidad de endeudamiento %
                  </div>
                  <div class="text-end m-auto" style="width: 15%">
                    {{
                      $filters.PercentFilter(operacion.capacidadEndeudamiento)
                    }}
                  </div>
                  <div
                    class="text-end m-auto"
                    style="width: 10%"
                    v-if="operacion.tipoProducto == 'Tradicional'"
                  >
                    <i
                      :class="
                        `bi bi-record-circle ms-3 iconoE ${obtenerColor(
                          'ce',
                          operacion.capacidadEndeudamiento
                        )}`
                      "
                    ></i>
                  </div>
                  <div
                    class="text-end m-auto"
                    style="width: 10%"
                    v-if="operacion.tipoProducto == 'Flexible'"
                  >
                    <i
                      :class="
                        `bi bi-record-circle ms-3 iconoE ${obtenerColorFlex(
                          'ce',
                          operacion.capacidadEndeudamiento
                        )}`
                      "
                    ></i>
                  </div>
                  <div class="text-end m-auto" style="width: 15%"></div>
                  <div class="text-end m-auto" style="width: 10%"></div>
                </div>

                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div class="m-auto" style="width: 40%">
                    Loan to value Actual % (LTV)
                  </div>
                  <div class="text-end m-auto" style="width: 15%">
                    {{ $filters.PercentFilter(operacion.loanToValueActual) }}
                  </div>
                  <div class="text-end m-auto" style="width: 10%">
                    <i
                      :class="
                        `bi bi-record-circle ms-3 iconoE ${obtenerColor(
                          'ltv',
                          operacion.loanToValueActual
                        )}`
                      "
                    ></i>
                  </div>
                  <div class="text-end m-auto" style="width: 15%"></div>
                  <div class="text-end m-auto" style="width: 10%"></div>
                </div>

                <div
                  v-for="cliente in operacion.clientes"
                  :key="cliente.clienteId"
                >
                  <div
                    class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                  >
                    <div style="width: 40%">Score buró de crédito (pts)</div>
                    <div class="text-end m-auto" style="width: 15%">
                      {{ cliente.consultaBuroCredito.scoreBuro }}
                    </div>
                    <div class="text-end m-auto" style="width: 10%">
                      <i
                        :class="
                          `bi bi-record-circle ms-3 iconoE ${obtenerColor(
                            'bc',
                            cliente.consultaBuroCredito.scoreBuro
                          )}`
                        "
                      ></i>
                    </div>
                    <div class="text-end m-auto" style="width: 15%">
                      <div v-if="operacion.scoreBuroOS > 0.0">
                        {{ operacion.scoreBuroOS }}
                      </div>
                    </div>
                    <div class="text-end m-auto" style="width: 8%">
                      <div v-if="operacion.scoreBuroOS > 0.0">
                        <i
                          :class="
                            `bi bi-record-circle ms-3 iconoE ${obtenerColor(
                              'bc',
                              operacion.scoreBuroOS
                            )}`
                          "
                        ></i>
                      </div>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                  >
                    <div style="width: 40%">Probabilidad de pago BC %</div>
                    <div class="text-end m-auto" style="width: 15%">
                      {{
                        $filters.PercentFilter(
                          cliente.consultaBuroCredito.scoreBuroPorcentual
                        )
                      }}
                    </div>
                    <div class="text-end m-auto" style="width: 10%">
                      <i
                        :class="
                          `bi bi-record-circle ms-3 iconoE ${obtenerColor(
                            'bc',
                            cliente.consultaBuroCredito.scoreBuro
                          )}`
                        "
                      ></i>
                    </div>
                    <div class="text-end m-auto" style="width: 15%">
                      <div v-if="operacion.scoreBuroPorcentualOS > 0.0">
                        {{
                          $filters.PercentFilter(
                            operacion.scoreBuroPorcentualOS
                          )
                        }}
                      </div>
                    </div>
                    <div class="text-end m-auto" style="width: 8%">
                      <div v-if="operacion.scoreBuroPorcentualOS > 0.0">
                        <i
                          :class="
                            `bi bi-record-circle ms-3 iconoE ${obtenerColor(
                              'pbc',
                              operacion.scoreBuroPorcentualOS
                            )}`
                          "
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div style="width: 40%">Gastos notariales %</div>
                  <div class="text-end m-auto" style="width: 15%">
                    {{
                      $filters.PercentFilter(operacion.porcentajeGastoNotarial)
                    }}
                  </div>
                  <div class="text-end m-auto" style="width: 10%"></div>
                  <div class="text-end m-auto" style="width: 15%"></div>
                  <div class="text-end m-auto" style="width: 10%"></div>
                </div>
                <div class="col-10 mx-auto mt-auto">
                  <button
                    type="button"
                    class="btn btn-outline-primary rounded-pill w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#infoModal"
                  >
                    Información de parámetros
                  </button>
                </div>
              </div>
            </div>

            <div class="col-md-12 col-lg-6 col-sm-5">
              <div
                class="
                  card card-body
                  text-start
                  mb-3                 
                  cabeceraDetalleI
                  parametros
                "
              >
                <div
                  class="d-flex justify-content-between mb-3 ms-1 mt-2 texto"
                >
                  <div class="text-end m-auto" style="width: 100%">
                    <spam style="font-size:13px"></spam>
                  </div>
                  <div class="text-end m-auto" style="width: 100%">
                    <spam style="font-size:12px"></spam>
                  </div>
                </div>
                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div style="width: 60%">Score interno (pts)</div>
                  <div class="text-end m-auto" style="width: 50%">
                    {{ operacion.scoreInterno }}
                  </div>
                  <div class="text-end m-auto" style="width: 10%">
                    <i
                      :class="
                        `bi bi-record-circle iconoE ${obtenerColor(
                          'si',
                          operacion.scoreInterno
                        )}`
                      "
                    ></i>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div style="width: 60%">Rating score interno</div>
                  <div class="text-end m-auto" style="width: 50%">
                    {{ operacion.ratingScoreInterno }}
                  </div>
                  <div class="text-end m-auto" style="width: 10%">
                    <i
                      :class="
                        `bi bi-record-circle iconoE ${obtenerColor(
                          'rsi',
                          operacion.ratingScoreInterno
                        )}`
                      "
                    ></i>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div style="width: 60%">
                    Riesgo estimado (Política de crédito %)
                  </div>
                  <div class="text-end m-auto" style="width: 50%">
                    {{ $filters.PercentFilter(operacion.porcentajeRiesgo) }}
                  </div>
                  <div class="text-end m-auto" style="width: 10%">
                    <i
                      :class="
                        `bi bi-record-circle iconoE ${obtenerColor(
                          'rep',
                          operacion.porcentajeRiesgo
                        )}`
                      "
                    ></i>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div>Estrategia política de crédito recomendada:</div>
                  <div>{{ estrategiaConsolidada }}</div>
                </div>

                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div style="width: 60%">Contratos domiciliados:</div>
                  <div class="text-end m-auto" style="width: 50%">
                    {{ operacion.contratosDomiciliados }} de
                    {{ operacion.totalContratos }}
                  </div>
                  <div class="text-end m-auto" style="width: 10%">
                    <i
                      class="bi bi-check-lg verde"
                      v-if="
                        operacion.contratosDomiciliados ==
                          operacion.totalContratos
                      "
                    ></i>
                    <i class="bi bi-x-lg rojo" v-else></i>
                  </div>
                </div>

                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div>Estrategia política de crédito alternativa:</div>
                  <div>{{ estrategiaConsolidadaAlt }}</div>
                </div>

                <div
                  class="d-flex justify-content-between mb-3 ms-1 me-1 texto"
                >
                  <div style="width: 60%">Score Interno Ajustado x LTV:</div>
                  <div class="text-end m-auto" style="width: 50%">
                    {{ scroeBuroAjustado }}
                  </div>
                  <div class="text-end m-auto" style="width: 10%">
                    <i
                      :class="
                        `bi bi-record-circle iconoE ${obtenerColor(
                          'si',
                          scroeBuroAjustado
                        )}`
                      "
                    ></i>
                  </div>
                </div>

                <div class="col-10 mx-auto mt-auto">
                  <button
                    type="button"
                    class="btn btn-outline-primary rounded-pill w-100"
                    data-bs-toggle="modal"
                    data-bs-target="#infoModalB"
                  >
                    Información de parámetros
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-lg-12">
              <grafica-indice-pagos
                v-for="cliente in operacion.clientes"
                :key="cliente.otro"
                :cliente="cliente"
                :totalContratos="totalContratos"
                :integrante="integrante"
                :adjudicatario="adjudicatario"
                :adjudicado="adjudicado"
                :totalTotal="totalTotal"
                :total="total"
              >
              </grafica-indice-pagos>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <modal-parametros></modal-parametros>
</template>

<script>
import ModalParametros from "@/Aplicaciones/CCD/Areas/CCD/Componentes/ModalParametros.vue";
import GraficaIndicePagos from "@/Aplicaciones/CCD/Areas/CCD/Componentes/GraficaIndicePagos.vue";
import { defineComponent } from "vue";

export default defineComponent({
  name: "DetalleTableroControl",

  props: {
    operacion: {},
    scoreBuro: Number,
    totalContratos: Number,
    integrante: {},
    adjudicatario: {},
    adjudicado: {},
    total: {},
  },

  components: {
    ModalParametros,
    GraficaIndicePagos,
  },
  computed: {
    scroeBuroAjustado() {
      let ajuste = 0,
        ajustado = 0,
        scoreBuro = this.operacion.scoreInterno;
      ajuste =
        (67.5 - this.operacion.loanToValueActual) *
        0.7 *
        (1 - scoreBuro / 1000);
      ajustado = scoreBuro * (1 + ajuste / 100);
      return ajustado > 800 ? 800 : ajustado < 300 ? 300 : ajustado.toFixed(0);
    },
    estrategiaConsolidada() {
      if (this.operacion.estrategiaConsolidada.includes("|")) {
        return this.operacion.estrategiaConsolidada.split("|")[0];
      } else {
        return this.operacion.estrategiaConsolidada;
      }
    },
    estrategiaConsolidadaAlt() {
      if (this.operacion.estrategiaConsolidada.includes("|")) {
        return this.operacion.estrategiaConsolidada.split("|")[1];
      } else {
        return "-";
      }
    },
  },

  methods: {
    calcularIngresosTotales(ingresos) {
      let total = ingresos.reduce(function(accumulator, currentValue) {
        return accumulator + currentValue.montoIngreso;
      }, 0);
      return total;
    },

    obtenerColor(clave, valor) {
      if (clave == "cp") {
        if (valor <= 28.5 && valor > 0.0) {
          return "amarillo";
        }
        if (valor >= 28.6 && valor <= 33.5) {
          return "naranja";
        }
        if (valor > 33.5) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
      if (clave == "ce") {
        if (valor <= 40 && valor > 0.0) {
          return "amarillo";
        }
        if (valor >= 40.1 && valor <= 45) {
          return "naranja";
        }
        if (valor > 45) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
      if (clave == "ltv") {
        if (valor <= 65 && valor > 0.0) {
          return "amarillo";
        }
        if (valor >= 65.1 && valor <= 69) {
          return "naranja";
        }
        if (valor > 69) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
      if (clave == "si") {
        if (valor == 0) {
          return "gris";
        }
        if (valor >= 300 && valor <= 425) {
          return "rojo";
        }
        if (valor >= 426 && valor <= 550) {
          return "naranja";
        }
        if (valor >= 551 && valor <= 675) {
          return "amarillo";
        }
        if (valor >= 676 && valor <= 800) {
          return "verde";
        }
      }
      if (clave == "rsi") {
        if (valor == "BB") {
          return "gris";
        }
        if (valor == "BBB") {
          return "rojo";
        }
        if (valor == "A") {
          return "naranja";
        }
        if (valor == "AA") {
          return "amarillo";
        }
        if (valor == "AAA") {
          return "verde";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
      if (clave == "rep") {
        if (valor <= 4.0 && valor > 0.0) {
          return "verde";
        }
        if (valor >= 4.1 && valor <= 6) {
          return "amarillo";
        }
        if (valor >= 6.1 && valor <= 10) {
          return "naranja";
        }
        if (valor < 10 && valor > 0.0) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
      if (clave == "bc") {
        if (valor > 695) {
          return "amarillo";
        }
        if (valor >= 580 && valor <= 695) {
          return "naranja";
        }
        if (valor < 580 && valor > 0.0) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
      if (clave == "pbc") {
        if (valor > 75) {
          return "amarillo";
        }
        if (valor >= 55 && valor <= 75) {
          return "naranja";
        }
        if (valor < 55 && valor > 0.0) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
    },
    obtenerColorFlex(clave, valor) {
      if (clave == "cp") {
        if (valor <= 28.5 && valor > 0.0) {
          return "amarillo";
        }
        if (valor >= 28.6 && valor <= 33.5) {
          return "naranja";
        }
        if (valor > 33.5) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
      if (clave == "ce") {
        if (valor <= 40 && valor > 0.0) {
          return "amarillo";
        }
        if (valor >= 40.1 && valor <= 45) {
          return "naranja";
        }
        if (valor > 45) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
      if (clave == "bc") {
        if (valor > 695) {
          return "amarillo";
        }
        if (valor >= 580 && valor <= 695) {
          return "naranja";
        }
        if (valor < 580 && valor > 0.0) {
          return "rojo";
        }
        if (valor == 0.0) {
          return "gris";
        }
      }
    },
  },
});
</script>

<style scoped>
.texto,
p,
span {
  font-family: Montserrat;
  font-style: normal;
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: #302d74;
}

.btn {
  z-index: 10;
  font-weight: 600;
  font-size: 18px;
}

.parametros {
  min-height: 400px;
}

.iconoE {
  font-size: 30px !important;
}

.espacioIcono {
  margin-top: -4px;
}
</style>
